export default __webpack_public_path__ + "static/media/80.f8512d41.png";